var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.828 4.778H12C12.5523 4.778 13 5.22572 13 5.778V5.778C13 6.33028 12.5523 6.778 12 6.778H3.828L6.485 9.435C6.87547 9.82547 6.87547 10.4585 6.485 10.849V10.849C6.09453 11.2395 5.46147 11.2395 5.071 10.849L0.316603 6.0946C0.141748 5.91975 0.141748 5.63625 0.316603 5.4614L5.071 0.707C5.46147 0.316535 6.09453 0.316535 6.485 0.707V0.707C6.87547 1.09747 6.87547 1.73053 6.485 2.121L3.828 4.778Z",
    fill: "#091F82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.172 13.778H11C10.4477 13.778 10 14.2257 10 14.778V14.778C10 15.3303 10.4477 15.778 11 15.778H19.172L16.515 18.435C16.1245 18.8255 16.1245 19.4585 16.515 19.849V19.849C16.9055 20.2395 17.5385 20.2395 17.929 19.849L22.6834 15.0946C22.8583 14.9197 22.8583 14.6363 22.6834 14.4614L17.929 9.707C17.5385 9.31653 16.9055 9.31653 16.515 9.707V9.707C16.1245 10.0975 16.1245 10.7305 16.515 11.121L19.172 13.778Z",
    fill: "#091F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.0af9f66542b8b4130e712cf596794e41.svg";
export { ForwardRef as ReactComponent };